import {formatDecimal, formatNumber} from '../../../../../library/numberFunction';
import * as css from './Detail.css';

function Detail({value,sign,text , isSymbol=false, className='', number=false}) {
    
    const isValueValid = Number.isFinite(value) || 
                        (typeof value === 'string' && !isNaN(parseFloat(value.replace(/,/g, ''))));

    return (
        <css.detail className={className} >
            {isSymbol?
                <>
                    <span>{sign}</span>{isValueValid ? (number ? formatNumber(value, true) : formatDecimal(value)) : 0}
                </>:
                <>
                    {isValueValid ? (number ? formatNumber(value, true) : formatDecimal(value)) : 0}<span>{sign}</span>
                </>
            }
            <css.text>{text}</css.text>
        </css.detail>
    );
}
export default Detail;
